import { render, staticRenderFns } from "./Tzggcx.vue?vue&type=template&id=4756b1c4"
import script from "./Tzggcx.vue?vue&type=script&lang=js"
export * from "./Tzggcx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports